module.exports = __webpack_public_path__ + "3ba43bc9cca7668758ca02050bff7b2e.MP3";